export default () => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div data-jcs-element="provider__container" class="provider-container"></div>
<form class="q-my-lg">
  <button class="button button--tertiary text-weight-medium full-width" data-jcs-element="gateway__upload__toggle" aria-label="Button Title">
    <div data-jcs-element="gateway__upload__toggle__upload__label" class="row items-center">
      <i class="eva eva-upload text-grey-8 text-h5 q-mr-md"></i>
      {{MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE}}
    </div>
    <div data-jcs-element="gateway__upload__toggle__camera__label" class="row items-center">
      <i class="eva eva-camera-outline text-grey-8 text-h5 q-mr-md"></i>
      {{MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE}}
    </div>
  </button>
</form>
  `
});
